import React from 'react'

function Card({name,role,text,picture,photo,link}) {
    function getText(link, text){
        if(link){
            return (
                <a href={link} target="_blank" rel="noreferrer">{text}</a>
            )
        } else {
            return (
                <p> {text} </p>
            )
        }
    }
    return (
        <div className='Card'>
            <div className='upper-card'>
                <div className='image-card'>
                    <figure className="swap-on-hover">
                        <img src={picture} alt="profilePic" height="148px" width="148px"/>
                        <img className= "image-hover"src={photo} alt="profilePic" height="148px" width="148px"/>
                    </figure>
                </div>
            </div>
            <div className="lower-card">
                <h3> {name} </h3>
                <h5> {role} </h5>
                {getText(link,text)}
            </div>
        </div>
    )
}

export default Card
